<script lang="ts" setup>
// ====---------------====
// 🚀 Imports
// ====---------------====
import { onMounted } from 'vue'
import { useSelectedPlanStore } from '@/stores/plans/selectedPlan.ts'
import { lrIdentify } from '@/utils/tracking'

// ====---------------====
// 🏪 Stores
// ====---------------====
const planStore = useSelectedPlanStore().getStore()

// ====---------------====
// 🌄 Lifecycle
// ====---------------====
onMounted(() => {
	lrIdentify({
		uid: planStore.username,
		props: {
			userName: planStore.username,
			memberId: planStore.memberId,
			groupId: planStore.groupNumber,
			planType: planStore.lobDisplayName,
			lob: planStore.tier1,
			contractType: planStore.contractType
		}
	})
})
</script>
